import { all, call } from "redux-saga/effects"

import { listFetchingFlow } from "./list/actions"

export function* lessonsSaga() {
  yield all([call(listFetchingFlow)])
}

export { fetchLessonsList } from "./list/actions"
